'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { VisitorIDSetProps, TrackingFunction } from '../types';

export const useVisitorIDTracking = (props: VisitorIDSetProps, autoTrack: boolean = false): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.VISITOR_ID_SET,
      properties: props,
    },
    autoTrack,
  );
};
